import {useEffect, useState} from 'react';
import {WiringDiagrams} from './wiring-diagrams';
import {useRouter} from 'next/router';

export function MainComponent() {
  const [choices, setChoices] = useState(null);
  const router = useRouter();

  useEffect(() => {
    const params = router.query;
    // console.log({ params })
    setChoices(params);
  }, [router]);

  const ratio = 822 / 250;
  const width = 300;
  const height = width / ratio;

  return (
    <div className='local-bootstrap'>
      <div className='px-0' style={{minHeight: '80vh'}}>
        <WiringDiagrams
          didChoose={(newChoices) => {
            setChoices(newChoices);
          }}
          resetChoices={() => {
            setChoices(null);
          }}
          choices={choices}
        />
      </div>
    </div>
  );
}
